import React from "react";
import PrintIcon from "@mui/icons-material/Print";
import ButtonPolicy from "./Permission/ButtonPolicy";
import jsPDF from "jspdf";
import "jspdf-autotable";
import barChart from "src/img/columns.png";
import cake from "src/img/cake.png";
import { useAlertContext } from "src/hooks/use-alert";

const GeneratePDFContainer = ({ type, rows, columns }) => {
  const alert = useAlertContext();

  const isRowsPresent = (rows.length > 0 ? true : false);

  const generatePDF = () => {
    const doc = new jsPDF();
    const tableData = [];

    // Prepare the data for the table
    rows.forEach((row, rowIndex) => {
      const rowData = columns.map((column) => row[column.field]);
      tableData.push(rowData);
    });

    doc.autoTable({
      margin: { top: 10, right: 10, bottom: 0, left: 10 },
      bodyStyles: { minCellHeight: 15, valign: "middle" },
      head: [columns.map((column) => column.headerName)],
      body: tableData,
      // Add image to 'Chart' column
      didDrawCell: (data) => {
        if (
          data.column.index ===
            columns.findIndex((col) => col.headerName === "Chart") &&
          data.section === "body"
        ) {
          const cellWidth = data.cell.width - 8;
          const cellHeight = data.cell.height;
          const imageWidth = 5; // Adjust as needed
          const imageHeight = 5; // Adjust as needed
          const x1 = data.cell.x + (cellWidth - imageWidth) / 2;
          const y = data.cell.y + (cellHeight - imageHeight) / 2;
          const x2 = x1 + imageWidth + 2;
          doc.addImage(cake, x1, y, imageWidth, imageHeight);
          doc.addImage(barChart, x2, y, imageWidth, imageHeight);
        }
      },
    });
    // Save or download the PDF
    doc.save(type);

    // Setting alert message
    alert.setSuccess((prev) => [
      ...prev,
      {
        status: true,
        message: "PDF downloaded succesfully",
        index: prev.length,
      },
    ]);
  };

  const handleNoPDF = () => {
    // Setting alert message
    alert.setError((prev) => [
      ...prev,
      {
        status: true,
        message: "No data is available to be downloaded",
        index: prev.length,
      },
    ]);
  }

  return (
    <ButtonPolicy onClick={isRowsPresent ? generatePDF : handleNoPDF}>
      <PrintIcon className="pdfIcon" />
    </ButtonPolicy>
  );
};

export default GeneratePDFContainer;
